import axios from 'axios'
import router from '../router' // Import the router to handle navigation

const baseURL = process.env.VUE_APP_API_BASE_URL || 'https://localhost/api'

const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 10000 // A reasonable global timeout
})

// Add a response interceptor
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    // Check if the error is due to an expired/invalid session
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.log('Authentication error detected by interceptor.')

      // Remove the invalid token from localStorage. This breaks the redirect loop.
      localStorage.removeItem('user-token')

      // Redirect to the login page.
      // We check to avoid redirecting if we are already on the login page.
      if (router.currentRoute.value.name !== 'Login') {
        router.push({ name: 'Login' })
      }
    }

    // Also handle timeouts for user feedback
    if (error.code === 'ECONNABORTED') {
      console.error('Request timed out:', error.message)
      // You could trigger a global notification here
      // alert('The server is taking too long to respond.');
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
